import _asyncToGenerator from "/buddy/cc-maintainer-fe/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/buddy/cc-maintainer-fe/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import { authGuard, loginGuard } from "./routeGuards";
var routes = [{
  path: '/',
  component: function component() {
    return import('layouts/BlankLayout.vue');
  },
  children: [{
    path: '',
    alias: 'login',
    name: 'login',
    beforeEnter: loginGuard(),
    component: function () {
      var _component = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", import('pages/Login.vue'));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function component() {
        return _component.apply(this, arguments);
      }
      return component;
    }()
  }, {
    path: 'mfa',
    name: 'mfa',
    component: function component() {
      return import('pages/MFA.vue');
    }
  }]
}, {
  path: '/',
  component: function component() {
    return import('layouts/MainLayout.vue');
  },
  beforeEnter: authGuard('access:maintainer'),
  children: [
  // Dashboard
  {
    path: 'dashboard',
    component: function component() {
      return import('pages/Index.vue');
    },
    name: 'dashboard'
  },
  // Split Panel
  {
    path: 'split-panel',
    name: 'splitPanel',
    beforeEnter: authGuard('access:split_panel'),
    component: function component() {
      return import('pages/SplitPanel.vue');
    }
  },
  // CUI Medline Plus Detach
  {
    path: 'cui-medline-plus-detach',
    name: 'cuiMedlinePlusDetach',
    beforeEnter: authGuard('access:cui_medline_plus'),
    component: function component() {
      return import('pages/concept-detach/CuiMedlinePlusDetach.vue');
    }
  },
  // CUI Wiki Detach
  {
    path: 'cui-wiki-detach',
    name: 'cuiWikiDetach',
    beforeEnter: authGuard('access:cui_wiki'),
    component: function component() {
      return import('pages/concept-detach/CuiWikiDetach.vue');
    }
  },
  // CUI Detach
  {
    path: 'cui-detach',
    name: 'cuiQueryDetach',
    beforeEnter: authGuard('access:cui_query_detach'),
    component: function component() {
      return import('pages/concept-detach/CuiDetach.vue');
    }
  },
  // WUI Detach
  {
    path: 'wui-detach',
    name: 'wuiQueryDetach',
    beforeEnter: authGuard('access:wui_query_detach'),
    component: function component() {
      return import('pages/concept-detach/WuiDetach.vue');
    }
  },
  // Reddit CUI Detach
  {
    path: 'reddit-cui-detach',
    name: 'redditCuiDetach',
    beforeEnter: authGuard('access:cui_reddit_detach'),
    component: function component() {
      return import('pages/concept-detach/RedditCuiDetach.vue');
    }
  },
  // Reddit WUI Detach
  {
    path: 'reddit-wui-detach',
    name: 'redditWuiDetach',
    beforeEnter: authGuard('access:wui_reddit_detach'),
    component: function component() {
      return import('pages/concept-detach/RedditWuiDetach.vue');
    }
  },
  // Wiki Categories
  {
    path: 'wiki-categories',
    name: 'wikiCategories',
    beforeEnter: authGuard('access:wiki_categories'),
    component: function component() {
      return import('pages/concept-detach/WikiCategoriesEditor.vue');
    }
  },
  // Reports

  // UndoActions
  {
    path: 'reports',
    name: 'reports',
    component: function component() {
      return import('pages/reports/Reports.vue');
    },
    children: [{
      path: 'undo-actions',
      name: 'reportsUndoActions',
      component: function component() {
        return import('pages/reports/UndoActions.vue');
      }
    }, {
      path: 'undo-actions/:adminId',
      name: 'reportsUndoActionsAdmin',
      component: function component() {
        return import('pages/reports/UndoActionsAdmin.vue');
      }
    }]
  },
  // Administration

  // Export
  {
    path: 'export',
    name: 'export',
    beforeEnter: authGuard('access:export'),
    component: function component() {
      return import('pages/Export.vue');
    }
  },
  // Users
  {
    path: 'users',
    component: function component() {
      return import('pages/Content.vue');
    },
    beforeEnter: authGuard('read:admins', 'write:admins'),
    children: [{
      path: '',
      name: 'users',
      component: function component() {
        return import('pages/Users.vue');
      }
    }]
  },
  // Activity Log
  {
    path: 'activity-log',
    name: 'activityLog',
    beforeEnter: authGuard('read:activity_logs'),
    component: function component() {
      return import('pages/activity-log/ActivityLogList');
    }
  },
  // DevTools
  {
    path: 'dev-tools',
    name: 'devTools',
    beforeEnter: authGuard('access:dev_tools'),
    component: function component() {
      return import('pages/DevTools.vue');
    }
  },
  // My account
  {
    path: 'my-account',
    component: function component() {
      return import('pages/MyAccount.vue');
    }
  }]
}, {
  path: '/wiki-categories',
  component: function component() {
    return import('layouts/BlankLayout.vue');
  },
  beforeEnter: authGuard('access:wiki_categories'),
  children: [{
    path: ':rootId/report',
    name: 'wikiCategoriesReport',
    component: function component() {
      return import('pages/concept-detach/WikiCategoriesReport.vue');
    }
  }]
},
// AUTH

{
  path: '/forgot-password',
  component: function component() {
    return import('layouts/BlankLayout.vue');
  },
  children: [{
    path: '',
    name: 'forgot-password',
    component: function component() {
      return import('pages/ForgotPassword.vue');
    }
  }]
}, {
  path: '/reset-password',
  component: function component() {
    return import('layouts/BlankLayout.vue');
  },
  children: [{
    path: ':token',
    name: 'reset-password',
    component: function component() {
      return import('pages/ResetPassword.vue');
    }
  }]
}, {
  path: '/not-authorized',
  component: function component() {
    return import('layouts/MainLayout.vue');
  },
  children: [{
    path: '',
    name: 'notAuthorized',
    component: function component() {
      return import('pages/NotAuthorized.vue');
    }
  }]
}];

// Always leave this as last one
if (process.env.MODE !== 'ssr') {
  // TODO REMOVE && routes
  routes.push({
    path: '*',
    component: function component() {
      return import('pages/Error404.vue');
    }
  });
}
export default routes;